import React from 'react';
import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminHeader() {
  const { user } = useAuth();
  const navigate  = useNavigate();

  return (
    <header className="page-header flex items-center justify-between">

      {/* Brand */}
      <div className="flex items-center gap-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-full flex-shrink-0"
             style={{
               background: 'linear-gradient(135deg, #b8860b 0%, #d4a017 40%, #f0c040 100%)',
               boxShadow: '0 2px 10px rgba(212,160,23,0.4)',
             }}>
          <svg viewBox="0 0 40 40" fill="none" className="h-4 w-4" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 5L26 14H14L20 5Z" fill="white" fillOpacity="0.9"/>
            <path d="M14 14L10 20L20 35L30 20L26 14H14Z" fill="white" fillOpacity="0.75"/>
          </svg>
        </div>
        <div>
          <p className="font-serif text-sm font-semibold leading-tight text-gold-shimmer">
            Shine Jewellery
          </p>
          <p className="text-[10px] leading-tight tracking-widest uppercase"
             style={{ color: 'rgba(212,160,23,0.5)' }}>
            Admin
          </p>
        </div>
      </div>

      {/* Right: admin name + settings icon */}
      <div className="flex items-center gap-3">
        {user?.name && (
          <span className="text-xs font-medium truncate max-w-[100px]"
                style={{ color: 'rgba(255,255,255,0.6)' }}>
            {user.name}
          </span>
        )}
        <button
          onClick={() => navigate('/settings')}
          aria-label="Settings"
          className="flex h-8 w-8 items-center justify-center rounded-xl transition-all duration-200 hover:scale-105 active:scale-95"
          style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)' }}
        >
          <Settings size={15} style={{ color: 'rgba(255,255,255,0.6)' }} />
        </button>
      </div>

    </header>
  );
}
